import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect, Route, Switch, useHistory} from 'react-router-dom';
import ReactGA from 'react-ga';
import message from 'antd/es/message';
import Loadable from 'react-loadable';
import {
  BottomNavbar,
  Footer,
  Navbar,
  NavbarLoggedIn,
  ScrollToTop,
} from './components';
import {PopupSubscription} from './pages/medpass/PopupSubscription';
import {client} from './apollo/apolloClient';
import {RESEND_EMAIL} from './apollo/schema';
import {changeLoginStatus, storeUserData} from './redux/actions/Util';
import {getAppComponentData} from './redux/selectors/selectors';
import {initiateOrDestroyChatUsingPath} from './helpers/util';
import './helpers/util.css';
import './App.css';

// if (process.env.NODE_ENV === 'development') {
//   whyDidYouRender(React, {
//     trackAllPureComponents: true,
//   });
// }

const Home = Loadable({
  loader: () => import('./pages/home/Home').then(module => module.Home),
  loading: () => '',
});

const Landing = Loadable({
  loader: () => import('./pages/landing/Landing').then(
      module => module.Landing),
  loading: () => '',
});

const UnsubscribeEmail = Loadable({
  loader: () => import('./pages/unsubscribe_email/UnsubscribeEmail').then(
      module => module.UnsubscribeEmail),
  loading: () => '',
});

const PageNotFound = Loadable({
  loader: () => import('./pages/404/PageNotFound').then(
      module => module.PageNotFound),
  loading: () => '',
});

const Challenges = Loadable({
  loader: () => import('./pages/challenges/Challenges').then(
      module => module.Challenges),
  loading: () => '',
});

const ChallengeCategoryDetailed = Loadable({
  loader: () => import('./pages/challenges/challenge_category_detailed/ChallengeCategoryDetailed').then(
      module => module.ChallengeCategoryDetailed),
  loading: () => '',
});

const ChallengeDetailed = Loadable({
  loader: () => import('./pages/challenges/challenge_detailed/ChallengeDetailed').then(
      module => module.ChallengeDetailed),
  loading: () => '',
});

const ChallengeExam = Loadable({
  loader: () => import('./pages/challenges/challenge_exam/ChallengeExam').then(
      module => module.ChallengeExam),
  loading: () => '',
});

const PrepMed = Loadable({
  loader: () => import('./pages/prepmed/PrepMed').then(
      module => module.PrepMed),
  loading: () => '',
});

const PrepMedCategoryDetailed = Loadable({
  loader: () => import('./pages/prepmed/prepmed_category_detailed/PrepMedCategoryDetailed').then(
      module => module.PrepMedCategoryDetailed),
  loading: () => '',
});

const PrepMedTestDetailed = Loadable({
  loader: () => import('./pages/prepmed/prepmed_test_detailed/PrepMedTestDetailed').then(
      module => module.PrepMedTestDetailed),
  loading: () => '',
});

const PrepMedTest = Loadable({
  loader: () => import('./pages/prepmed/prepmed_test/PrepMedTest').then(
      module => module.PrepMedTest),
  loading: () => '',
});

const PrepMedPracticeTest = Loadable({
  loader: () => import('./pages/prepmed/prepmed_practice_test/PrepMedPracticeTest').then(
      module => module.PrepMedPracticeTest),
  loading: () => '',
});

const GrandTest = Loadable({
  loader: () => import('./pages/prepmed/GrandTest/GrandTest').then(
      module => module.GrandTest),
  loading: () => '',
});
const MVideos = Loadable({
  loader: () => import('./pages/mvideos/MVideos').then(
      module => module.MVideos),
  loading: () => '',
});

const MVideoCategoryDetailed = Loadable({
  loader: () => import('./pages/mvideos/mvideo_category_detailed/MVideoCategoryDetailed').then(
      module => module.MVideoCategoryDetailed),
  loading: () => '',
});

const MVideoSubCategoryDetailed = Loadable({
  loader: () => import('./pages/mvideos/mvideo_sub_category_detailed/MVideoSubCategoryDetailed').then(
      module => module.MVideoSubCategoryDetailed),
  loading: () => '',
});

const MVideoDetailed = Loadable({
  loader: () => import('./pages/mvideos/mvideo_detailed/MVideoDetailed').then(
      module => module.MVideoDetailed),
  loading: () => '',
});

const MedPixx = Loadable({
  loader: () => import('./pages/medpixx/MedPixx').then(
      module => module.MedPixx),
  loading: () => '',
});

const MedPixxDetailed = Loadable({
  loader: () => import('./pages/medpixx/medpixx_detailed/MedPixxDetailed').then(
      module => module.MedPixxDetailed),
  loading: () => '',
});

const AboutUs = Loadable({
  loader: () => import('./pages/about-us/AboutUs').then(
      module => module.AboutUs),
  loading: () => '',
});

const InfoMed = Loadable({
  loader: () => import('./pages/infomed/InfoMed').then(
      module => module.InfoMed),
  loading: () => '',
});

const InfoMedDetailed = Loadable({
  loader: () => import('./pages/infomed/infomed_detailed/InfoMedDetailed').then(
      module => module.InfoMedDetailed),
  loading: () => '',
});

const MedBookNavigation = Loadable({
  loader: () => import('./pages/medbook/MedBookNavigation').then(
      module => module.MedBookNavigation),
  loading: () => '',
});

const ProfileNavigation = Loadable({
  loader: () => import('./pages/profile/ProfileNavigation').then(
      module => module.ProfileNavigation),
  loading: () => '',
});

const ContactUs = Loadable({
  loader: () => import('./pages/contact_us/ContactUs').then(
      module => module.ContactUs),
  loading: () => '',
});

const ForgotPassword = Loadable({
  loader: () => import('./pages/forgot_password/ForgotPassword').then(
      module => module.ForgotPassword),
  loading: () => '',
});

const PrivacyPolicy = Loadable({
  loader: () => import('./pages/privacy_policy/PrivacyPolicy').then(
      module => module.PrivacyPolicy),
  loading: () => '',
});

const LogIn = Loadable({
  loader: () => import('./pages/login/LogIn').then(module => module.LogIn),
  loading: () => '',
});

const LoginWithApple = Loadable({
  loader: () => import('./pages/login/LoginWithApple').then(
      module => module.LoginWithApple),
  loading: () => '',
});

const SignUp = Loadable({
  loader: () => import('./pages/signup/SignUp').then(module => module.SignUp),
  loading: () => '',
});

const ResetPassword = Loadable({
  loader: () => import('./pages/reset_password/ResetPassword').then(
      module => module.ResetPassword),
  loading: () => '',
});

const MedPass = Loadable({
  loader: () => import('./pages/medpass/MedPass').then(
      module => module.MedPass),
  loading: () => '',
});

const TermsAndConditions = Loadable({
  loader: () => import('./pages/terms_and_conditions/TermsAndConditions').then(
      module => module.TermsAndConditions),
  loading: () => '',
});

const Faqs = Loadable({
  loader: () => import('./pages/faqs/Faqs').then(
      module => module.Faqs),
  loading: () => '',
});

const VerifyEmail = Loadable({
  loader: () => import('./pages/verify_email/VerifyEmail').then(
      module => module.VerifyEmail),
  loading: () => '',
});

const PlayAndWin = Loadable({
  loader: () => import('./pages/play_and_win/PlayAndWin').then(
      module => module.PlayAndWin),
  loading: () => '',
});

let isBorn = false;

const App = () => {
  const {location, listen} = useHistory();
  const dispatch = useDispatch();
  const {emailVerified, isUserLoggedIn, userData, isUserPrime, serum} = useSelector(
      getAppComponentData);

  useEffect(() => {
    window.addEventListener('storage', event => logoutReload(event));

    if (localStorage.getItem('auth-token') !== null) {
      dispatch(changeLoginStatus(true));
      dispatch(storeUserData());
    } else initiateOrDestroyChatUsingPath(userData);

    if (process.env.NODE_ENV === 'production') {
      window.oncontextmenu = e => e.preventDefault();
      ReactGA.initialize('UA-142524003-1');
      ReactGA.pageview(location.pathname + location.search);
      listen(location => ReactGA.pageview(location.pathname + location.search));
    }

    return () => window.removeEventListener('storage',
        event => logoutReload(event));
  }, []);

  useEffect(() => {
    if (isBorn) {
      initiateOrDestroyChatUsingPath(userData);
    } else isBorn = true;
  }, [location]);

  const reloadApplication = () => {
    window.location.reload();
  };

  const logoutReload = event => {
    if (event.key === 'logout-event') {
      window.location.reload();
    }
  };

  const resend = () => {
    client.query({
      query: RESEND_EMAIL,
    }).then(res => {
      if (res.hasOwnProperty('errors')) {
        message.error('Something went wrong');
      } else message.success('Email has been sent');
    });
  };

  const module = location.pathname.split('/')[1];

  return (
      <>
        <ScrollToTop>
          {
            isUserLoggedIn && !emailVerified ? (
                    <div
                        data-show="true"
                        className="ant-alert ant-alert-warning ant-alert-no-icon ant-alert-banner text-center"
                    >
                      <span className="ant-alert-message">Please Verify Your Email. If verified <a
                          href="javascript:void(0);"
                          onClick={reloadApplication}>click here.</a></span>
                      <span className="ant-alert-message">If you haven't received any email <a
                          href="javascript:void(0);"
                          onClick={resend}>resend</a></span>
                      <span className="ant-alert-description"/>
                    </div>
                )
                : ''
          }
          {
            module === 'challenge' || module === 'test' || module ===
            'practice-test' || module === 'grand-test' ?
                null :
                isUserLoggedIn ?
                    <NavbarLoggedIn/> :
                    <Navbar/>
          }
          <div className="main-content">
            <Switch>
              <Route
                  path="/"
                  exact
                  component={Home}
              />
              <Route
                  path="/challenges/"
                  exact
                  component={Challenges}
              />
              <Route
                  exact
                  path={'/challenges/type=:challengesType'}
                  component={ChallengeCategoryDetailed}
              />
              <Route
                  exact
                  path={'/challenges/:challengeSlug'}
                  render={() => <ChallengeDetailed
                      isUserLoggedIn={isUserLoggedIn}/>}
              />
              <Route
                  path={'/challenge/:challengeId'}
                  render={() => {
                    if (isUserLoggedIn) {
                      return <ChallengeExam isUserPrime={isUserPrime}/>;
                    } else {
                      message.warn('You need to login to write test.');
                      return <Redirect to="/challenges/"/>;
                    }
                  }}
              />
              <Route
                  path="/prepmed/"
                  exact
                  component={PrepMed}
              />
              <Route
                  exact
                  path={'/prepmed/type=:prepMedType'}
                  component={PrepMedCategoryDetailed}
              />
              <Route
                  path="/prepmed/test/:testSlug"
                  exact
                  component={PrepMedTestDetailed}
              />
              <Route
                  path="/practice-test/:testId"
                  render={() => {
                    if (isUserLoggedIn && serum >= 0) {
                      return <PrepMedPracticeTest/>;
                    } else if (!isUserLoggedIn) {
                      message.warn('You need to login to write test.');
                      return <Redirect to="/prepmed/"/>;
                    } else {
                      message.warn('Don\'t have enough serum');
                      return <Redirect to="/prepmed/"/>;
                    }
                  }}
              />
              <Route
                  path="/test/:testId"
                  render={() => {
                    if (isUserLoggedIn && serum >= 0) {
                      return <PrepMedTest/>;
                    } else if (!isUserLoggedIn) {
                      message.warn('You need to login to write test.');
                      return <Redirect to="/prepmed/"/>;
                    } else {
                      message.warn('Don\'t have enough serum');
                      return <Redirect to="/prepmed/"/>;
                    }
                  }}
              />
              <Route
                  path="/grand-test/:testId"
                  render={() => {
                    if (isUserLoggedIn && serum >= 0) {
                      return <GrandTest/>;
                    } else if (!isUserLoggedIn) {
                      message.warn('You need to login to write test.');
                      return <Redirect to="/prepmed/"/>;
                    } else {
                      message.warn('Don\'t have enough serum');
                      return <Redirect to="/prepmed/"/>;
                    }
                  }}
              />
              <Route path="/medpixx/" exact component={MedPixx}/>
              <Route
                  path="/medpixx/:medpixxSlug"
                  component={MedPixxDetailed}
              />
              <Route path="/mvideos/" exact component={MVideos}/>
              <Route
                  path="/mvideos/:categorySlug/"
                  exact
                  component={MVideoCategoryDetailed}
              />
              <Route
                  path="/mvideos/:categorySlug/:subCategorySlug/"
                  exact
                  component={MVideoSubCategoryDetailed}
              />
              <Route
                  path="/mvideos/:categorySlug/:subCategorySlug/:mvideoSlug"
                  component={MVideoDetailed}
              />
              <Route path="/infomed/" exact render={InfoMed}/>
              <Route
                  path="/infomed/:infomedSlug"
                  component={InfoMedDetailed}
              />
              <Route path="/mnotes/" exact component={InfoMed}/>
              <Route path="/mnotes/:infomedSlug" component={InfoMedDetailed}/>
              <Route
                  path="/medbook"
                  render={() => {
                    if (isUserLoggedIn) {
                      return <MedBookNavigation/>;
                    } else {
                      message.warn('You need to login to enter medBook');
                      return <Redirect to="/"/>;
                    }
                  }}
              />
              <Route
                  path="/profile"
                  render={() => {
                    if (isUserLoggedIn) {
                      return <ProfileNavigation/>;
                    } else {
                      message.warn('You need to login to enter profile page');
                      return <Redirect to="/"/>;
                    }
                  }}
              />
              <Route path="/playwin/" component={PlayAndWin}/>
              <Route path="/medpass/" component={MedPass}/>
              <Route path="/login/" component={LogIn}/>
              <Route
                  path="/signin-with-apple/auth-token=:authToken&csrf=:csrf&refresh-token=:refreshToken"
                  component={LoginWithApple}/>
              <Route
                  path="/signin-with-apple/status=:loginStatus"
                  component={LoginWithApple}
              />
              <Route path="/signup/" component={SignUp}/>
              <Route path="/forgot-password/" component={ForgotPassword}/>
              <Route
                  path="/reset-password/token=:tokenID"
                  component={ResetPassword}
              />
              <Route
                  path="/verify-email/token=:token"
                  component={VerifyEmail}
              />
              <Route path="/contact-us/" component={ContactUs}/>
              <Route path={'/about-us/'} component={AboutUs}/>
              <Route path={'/features/'} component={Landing}/>
              <Route path={'/privacy-policy/'} component={PrivacyPolicy}/>
              <Route
                  path={'/terms-and-conditions/'}
                  component={TermsAndConditions}
              />
              <Route
                  path={'/faqs/'}
                  component={Faqs}
              />
              <Route
                  path={'/unsubscribe-email=:userEmail'}
                  component={UnsubscribeEmail}
              />
              <Route path="*" component={PageNotFound}/>
            </Switch>
          </div>
          {
            module === 'challenge' || module === 'test' || module ===
            'practice-test' || module === 'grand-test' ? '' :
                <>
                  <Footer/>
                  <BottomNavbar/>
                </>
          }
        </ScrollToTop>
        <PopupSubscription/>
      </>
  );
};

export default App;
